import { Project, Identifiable, List, list, Gantt, Zone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedProject, Linker } from "../linkers/types";

type Response = {
  _embedded: {
    projects: (LinkedProject & {
      activityRoot: Identifiable<List>;
      _links: {
        [key: string]: { href: string };
      };
    })[];
  };
};

function projectsToGantt(projects: Identifiable<Project>[]): Gantt {
  return {
    projects: projects.map((project) => ({
      ...project,
      lists: [project.rootList],
      shallow: true,
    })),
    constraints: [],
  };
}

function getZoneGantt(httpClient: HttpClient, linker: Linker) {
  return (zone: Identifiable<Zone>) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/projects/search/rsql?query=activityRoot.startDate=isnotnull=true and activityRoot.endDate=isnotnull=true and status.label!=pz_closed and template==false and zone.uuid==${zone.uuid}&projection=details&page=0&size=999999`,
        method: HttpMethods.GET,
      })
      .then(({ _embedded: { projects } }) => projects)
      .then<
        (Identifiable<LinkedProject> & { activityRoot: Identifiable<List> })[]
      >((promises) => Promise.all(promises))
      .then((projects) =>
        projects.map((project) => ({
          ...project,
          rootList: { ...list, ...project.activityRoot },
          isTemplate: project.isTemplate || project.template,
          tags: project.tags
            ? (project.tags as any).map((name: string) => ({ name }))
            : [],
        })),
      )
      .then(projectsToGantt);
}

export { getZoneGantt };
